import * as React from 'react';
function Settings() {
	return (
		<>
			<div id="General_Settings" className="vertical_tabcontent">
				<p className="pheadline">General Settings</p>
				<p>General Settings is the capital city of England.</p>
			</div>
		</>
	);
}

export default Settings;
